const f = (i) => {
  var s, y, l;
  const k = Object.keys(i ?? {}), e = Array.isArray(i == null ? void 0 : i[k[0]]) ? i == null ? void 0 : i[k[0]][0] : i == null ? void 0 : i[k[0]], p = {
    text: (s = e == null ? void 0 : e.link) == null ? void 0 : s.text,
    url: (y = e == null ? void 0 : e.link) == null ? void 0 : y.url,
    target: (l = e == null ? void 0 : e.link) == null ? void 0 : l.target
  }, x = e == null ? void 0 : e.display_title, A = e == null ? void 0 : e.cards;
  return {
    componentType: k[0],
    contentCardCarouselData: A,
    link: p,
    title: x
  };
};
export {
  f as default
};
//# sourceMappingURL=content-card-carousel-transformer.js.map
